module.exports = __webpack_public_path__ + "img/ToyFaces_Colored_BG_56.3e848f99.jpg";